import { render, staticRenderFns } from "./interviewSetting.vue?vue&type=template&id=2c0bde21&scoped=true&"
import script from "./interviewSetting.vue?vue&type=script&lang=js&"
export * from "./interviewSetting.vue?vue&type=script&lang=js&"
import style0 from "./interviewSetting.vue?vue&type=style&index=0&id=2c0bde21&scoped=true&lang=css&"
import style1 from "./interviewSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bde21",
  null
  
)

export default component.exports